import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { map, filter, withLatestFrom } from 'rxjs/operators';
import { ChangeMerchColor } from '@webapp/store/merch/action-creators';
import { CHANGE_MERCH_COLOR } from '@webapp/store/merch/actions';
import AppState from '@webapp/store/state';
import { merchStepToIndexMap } from '@webapp/utils/merch/constants';

export const merchProductChangeColor = (
  action$: Observable<ChangeMerchColor>,
  state$: Observable<AppState>
) =>
  action$.pipe(
    ofType(CHANGE_MERCH_COLOR),
    withLatestFrom(state$),
    map(([action, state]) => {
      const fieldName = 'Color';
      const index = merchStepToIndexMap[fieldName];
      if (window.analytics) {
        window.analytics.track('Product Updated', {
          product_id: state.merch.active?.product?.id,
          field_name: fieldName,
          field_value: action.colors,
          ...(typeof index !== 'undefined' ? { index } : null),
        });
      }
    }),
    filter(() => false)
  );
